<template>
    <div id="contatct-banner" class="banner-wrapper bg-light w-100 py-5">
        <div class="banner-vertical-center-work container text-light d-flex justify-content-center align-items-center py-5 p-0">
            <div class="banner-content col-lg-8 col-12 m-lg-auto text-center">
                <h2 class="h2 text-center col-12 py-5 mt-5 semi-bold-600">Kontak Kami</h2>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HeaderContact'
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;700&family=IBM+Plex+Serif&display=swap');

#contatct-banner {
    background-position: center center;
    background-size: cover;
    background: linear-gradient(180deg, rgb(0, 62, 41) 0%, rgba(255, 255, 255, 0.822) 100%);
    font-family: 'IBM Plex Serif', serif;
}

h2 {
    color: #fff;
    font-size: 38px;
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15), 0px 10px 10px rgba(0, 0, 0, 0.05);
}

</style>
